"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ConfirmationDialogTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styles = require("@mui/styles");

var _ModalConfirmationMessage = _interopRequireDefault(require("./ModalConfirmationMessage"));

var ConfirmationDialogTypes;
exports.ConfirmationDialogTypes = ConfirmationDialogTypes;

(function (ConfirmationDialogTypes) {
  ConfirmationDialogTypes["WARNING"] = "warning";
  ConfirmationDialogTypes["ERROR"] = "error";
})(ConfirmationDialogTypes || (exports.ConfirmationDialogTypes = ConfirmationDialogTypes = {}));

var defineColor = function defineColor(palette, type) {
  return type === ConfirmationDialogTypes.ERROR ? palette.error.main : palette.orange.main;
};

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    avatar: {
      backgroundColor: function backgroundColor(_ref2) {
        var type = _ref2.type;
        return defineColor(palette, type);
      },
      width: 36,
      height: 36
    },
    title: {
      fontSize: '18px!important'
    },
    root: {
      borderTop: function borderTop(_ref3) {
        var type = _ref3.type;
        return "4px solid ".concat(defineColor(palette, type));
      }
    },
    cancelButton: {
      height: 'auto',
      padding: spacing(0.5, 1)
    },
    submitButton: {
      backgroundColor: function backgroundColor(_ref4) {
        var type = _ref4.type;
        return defineColor(palette, type);
      },
      height: 'auto',
      padding: spacing(0.5, 1)
    }
  };
});

var ConfirmationModalDialog = function ConfirmationModalDialog(props) {
  var _props$type = props.type,
      type = _props$type === void 0 ? ConfirmationDialogTypes.WARNING : _props$type,
      children = props.children,
      modalProps = (0, _objectWithoutProperties2["default"])(props, ["type", "children"]);
  var classes = useStyles(props);
  return /*#__PURE__*/_react["default"].createElement(_ModalConfirmationMessage["default"], (0, _extends2["default"])({}, modalProps, {
    icon: type === ConfirmationDialogTypes.ERROR ? 'eye-slash' : 'exclamation-circle',
    width: "100%",
    backdropStyles: {
      top: 0
    },
    paperStyles: {
      marginBottom: 80
    },
    customClasses: classes,
    buttonsProps: {
      size: 'small'
    }
  }), children);
};

var _default = ConfirmationModalDialog;
exports["default"] = _default;